import { PageBanner, QuickTable, QuickTableFilterTabs } from "../../components";
import { CreateProductForm } from "./CreateProductForm";
import { productsDisplayFormatter } from "./productsDisplayFormatter";
import { IProductViewProps } from "./Products";
import { EditProductForm } from "./EditProductForm";
import { ProductDetailsModal } from "./ProductDetailsModal";
import { Route, Routes } from "react-router-dom";

import linkColoredIcon from "../../assets/icons/link-colored.svg";

export const View = (props: IProductViewProps) => {
  return (
    <>
      <PageBanner
        iconSource={linkColoredIcon}
        pageTitle={"Create & Manage Products"}
        pageSubtitle={
          "Products are items or services you sell to your customers"
        }
        pageDescription={
          "Create a product or service, create a payment link, send link to your customers, and receive payments securely."
        }
        linkTitle={"Create payment links for your products"}
        linkSubtitle={"Create a custom payment page and share a link to it.."}
        linkButtonText={"Create payment link"}
        linkButtonUrl={"create"}
        linkButtonAction={props.openCreatePaymentLinkModal}
      />

      <QuickTable
        id="productsTable"
        data={props.data}
        headers={props.headers}
        isLoading={props.isLoading}
        isError={props.isError}
        itemCount={props.totalCount}
        renderDetail={(item) => item.product_description}
        toolbarTabs={
          <QuickTableFilterTabs
            queryStringTabNavLinks={props.queryStringTabs}
          />
        }
        displayFormatter={productsDisplayFormatter}
        onExport={props.onExport}
        openCreateNewModal={props.openCreateNewModal}
        createNewButtonText="New Product"
        openDetailsModal={props.openDetailsModal}
      />

      <Routes>
        <Route
          path="create"
          element={
            <CreateProductForm
              refreshTable={props.refreshTable}
              goBackOnClose={false}
            />
          }
        />
        <Route path=":id/details" element={<ProductDetailsModal />} />
        <Route
          path=":id/edit"
          element={<EditProductForm refreshTable={props.refreshTable} />}
        />
      </Routes>
    </>
  );
};
